module.exports = __webpack_public_path__ + "img/svg/result-loser-background.9a31898d023d1292eb20ba816d22d4ee.svg";